import { render, staticRenderFns } from "./Glb_video.vue?vue&type=template&id=8fe3b316&scoped=true&"
import script from "./Glb_video.vue?vue&type=script&lang=js&"
export * from "./Glb_video.vue?vue&type=script&lang=js&"
import style0 from "./Glb_video.vue?vue&type=style&index=0&id=8fe3b316&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe3b316",
  null
  
)

export default component.exports